import { Chip } from "@mui/material";

const adminChipEn = (
  <Chip label="Admin" size="small" color="primary" variant="filled" />
);
const userChipEn = (
  <Chip label="User" size="small" color="default" variant="outlined" />
);
const adminChipHeb = (
  <Chip label="מנהל" size="small" color="primary" variant="filled" />
);
const userChipHeb = (
  <Chip label="משתמש" size="small" color="default" variant="outlined" />
);

export const tableLayout = {
  en: [
    { width: 200, label: "Name", dataKey: "name", type: "cell" },
    { width: 260, label: "Email", dataKey: "email", type: "cell" },
    {
      width: 110,
      label: "Role",
      dataKey: "role",
      type: "map",
      hashmap: { admin: adminChipEn, user: userChipEn },
    },
    { width: 160, label: "Group", dataKey: "group", type: "cell" },
    { width: 90, label: "Active", dataKey: "active", type: "checkbox" },
    { width: 130, label: "Actions", dataKey: "actions", type: "actions" },
  ],
  heb: [
    { width: 200, label: "שם", dataKey: "name", type: "cell" },
    { width: 260, label: "דוא\"ל", dataKey: "email", type: "cell" },
    {
      width: 110,
      label: "תפקיד",
      dataKey: "role",
      type: "map",
      hashmap: { admin: adminChipHeb, user: userChipHeb },
    },
    { width: 160, label: "קבוצה", dataKey: "group", type: "cell" },
    { width: 90, label: "פעיל", dataKey: "active", type: "checkbox" },
    { width: 130, label: "פעולות", dataKey: "actions", type: "actions" },
  ],
};
